export default {
  loginRequired: [1000, 1001, 1002], // 状态码在这里面就跳转到登录页面
  noAuth: 1021 // 没有权限访问的状态码
}
